/**
 * @desc 更新
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.AppDomainRoleRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/modify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
